import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReset = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.34266 6.34318C9.46685 3.21898 14.5322 3.21898 17.6564 6.34318C20.7806 9.46737 20.7806 14.5327 17.6564 17.6569C17.2658 18.0474 17.2658 18.6806 17.6564 19.0711C18.0469 19.4616 18.6801 19.4616 19.0706 19.0711C22.9758 15.1659 22.9758 8.83421 19.0706 4.92896C15.1653 1.02372 8.83369 1.02372 4.92844 4.92896C1.21279 8.64462 1.0324 14.5568 4.3873 18.4857H3C2.44771 18.4857 2 18.9335 2 19.4857C2 20.038 2.44771 20.4857 3 20.4857L7 20.4857C7.55229 20.4857 8 20.038 8 19.4857L8 16C8 15.4477 7.55229 15 7 15C6.44772 15 6 15.4477 6 16L6 17.2925C3.22298 14.1505 3.33719 9.34864 6.34266 6.34318ZM12 6.00001C12.5523 6.00001 13 6.44773 13 7.00001V11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H12C11.4477 13 11 12.5523 11 12V7.00001C11 6.44773 11.4477 6.00001 12 6.00001Z",
		fill: "currentColor"
	})
});
export default SvgReset;
